export class DatiContabiliVO {
    voceBilancio: string; // solo per decreto contabile
    importo: string; // solo per decreto contabile
    area: string;
    capienza: string;
    residuo: string;
    conto: string;
    dataInizio: string;
    dataFine: string;
    esercizio: string;
    periodo: string;
}